<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
      <div class="col-9 h5 text-muted p-0">{{ pageTitle }}</div>
      <div class="col-2 p-0">
        <button type="button" class="btn btn-outline-danger btn-sm float-end" *ngIf="pageMode == 'edit'" (click)="onDeleteSmsCampaignClick(sms_campaign_save_confirm_modal)">Delete Campaign</button>
      </div>
      <div class="col-1 p-0">
        <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back" (click)="onBackClick()">
          <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>
  
    <div class="row bg-light p-2">
      <div class="col-12">
  
        <div class="row pt-2 pb-2 bg-white">
          <div class="col-12">

            <div class="row">
              <!-- Left -->
              <div class="col-6">

                <!-- Campaign name ====================================== -->
                <div class="row mt-2">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      Campaign Name
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Add name of the campaign. Max no of characters are 100."
                        placement="top">
                      </i-bs>
                    </span>

                    <span class="float-end text-muted small lh-lg">{{ campaignName?.length }}/100</span>

                    <input type="text" class="form-control mt-2" id="campaign_name" maxlength="100" placeholder="E.g. Black Friday Sale" [(ngModel)]="campaignName">
                  </div>
                </div>

                <!-- Stores ====================================== -->
                <div class="row mt-4">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      Stores
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Select stores for the sms campaign. Campaign type 'New' is always for single store."
                        placement="top">
                      </i-bs>
                    </span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <ng-multiselect-dropdown
                      [disabled]="storeSelectionDisabled"
                      [placeholder]="'Select'"
                      [settings]="storeSelectionSettings"
                      [data]="stores"
                      [(ngModel)]="campaignStores"
                      (onSelect)="onStoreSelect($event)"
                      (onDeSelect)="onStoreDeSelect($event)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>

                <!-- Campaign type ====================================== -->
                <div class="row mt-4">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      Campaign Type
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Select campaign type - New users(csv file with 'user_mobile' field) or Existing users"
                        placement="top">
                      </i-bs>
                    </span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12" >
                    <div class="btn-group btn-group-sm float-start">
                      <label [class]="campaignType === 'new' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="new" tabindex="0" role="button" (click)="onCampaignTypeChange('new')">&nbsp;&nbsp;&nbsp;New&nbsp;&nbsp;&nbsp;</label>
                      <label [class]="campaignType === 'existing' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'" btnRadio="existing" tabindex="0" role="button" (click)="onCampaignTypeChange('existing')">Existing</label>
                    </div>

                    <div class="float-end lh-lg" *ngIf="pageMode == 'add'">
                      <ngx-dropzone style="height: 30px; font-size: 11px; padding: 10px;" [multiple]="false" (change)="onCsvSelect($event)" *ngIf="campaignType == 'new'">
                        <ngx-dropzone-label>Select csv file</ngx-dropzone-label>
                      </ngx-dropzone>

                      <div class="spinner-grow spinner-grow-sm text-info" role="status" *ngIf="campaignType == 'existing' && customerMobileLoading == true"></div>
                    </div>
                  </div>
                </div>

                <!-- User list ====================================== -->
                <div class="row mt-4">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      Target Users Count
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Total number of target users."
                        placement="top">
                      </i-bs>
                    </span>

                    <div class="float-end">
                      <span class="badge rounded-pill bg-dark">{{ targetUserCount }}</span>
                    </div>
                    <!--<ag-grid-angular
                      style="width: 100%; height: 300px;"
                      class="ag-theme-alpine mt-3"
                      [columnDefs]="columnDefs"
                      [defaultColDef]="defaultColDef"
                      [rowData]="userDataCSV"
                      [rowSelection]="'multiple'"
                      [animateRows]="true">
                    </ag-grid-angular>-->
                  </div>
                </div>

              </div>

              <!-- Right -->
              <div class="col-6">

                <!-- Campaign date ====================================== -->
                <div class="row mt-2">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      Campaign Date
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Select campaign date."
                        placement="top">
                      </i-bs>
                    </span>

                    <input type="text" class="form-control text-muted mt-2" id="campaign_date" placeholder="Select sms campaign date" bsDatepicker [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [bsValue]="campaignDate" (bsValueChange)="onCalendarValueChange($event)">
                  </div>
                </div>

                <!-- SMS Text ====================================== -->
                <div class="row mt-4">
                  <div class="col-12">
                    <span class="text-muted fw-bold">
                      SMS Text
                      <i-bs
                        name="infoCircle"
                        class="text-primary"
                        tooltip="Enter SMS text. Max no of characters are 160."
                        placement="top">
                      </i-bs>
                    </span>

                    <span class="float-end text-muted small lh-lg">{{ campaignSmsText?.length }}/160</span>

                    <textarea class="form-control mt-2" id="campaign_sms_text" maxlength="160" rows="7" placeholder="Enter sms text here..." [(ngModel)]="campaignSmsText"></textarea>
                  </div>
                </div>
                
              </div>

            </div>

            <!-- Save Button -->
            <div class="row mt-3 pt-3 mb-0 border-top">
              <div class="col-6">
              </div>
              <div class="col-6 text-end">
                <button type="button" class="btn btn-secondary text-white fw-bold" title="Save SMS Campaign" (click)="onSaveSmsCampaignClick(sms_campaign_save_confirm_modal)">
                  <i-bs class="text-light" name="cloudArrowUp" width="22" height="22"></i-bs>
                </button>
              </div>
            </div>

          </div>
        </div>
  
      </div>
    </div>
  </div>

  <!-- SMS Campaign Save Confirm Modal -->
  <ng-template #sms_campaign_save_confirm_modal>
    <div class="modal-header">
      <h6 class="modal-title text-muted float-start" *ngIf="pageMode == 'add'">Create SMS Campaign</h6>
      <h6 class="modal-title text-muted float-start" *ngIf="pageMode == 'edit' &&  isDeleteSmsCampaign == false">Edit SMS Campaign</h6>
      <h6 class="modal-title text-danger float-start" *ngIf="pageMode == 'edit' &&  isDeleteSmsCampaign == true">Delete SMS Campaign</h6>

      <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideSmsCampaignSaveConfirmModal()"></i-bs>
    </div>

    <div class="modal-body">
      <p class="text-muted" *ngIf="pageMode == 'add'">Are you sure you want to create this sms campaign?</p>
      <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeleteSmsCampaign == false">Are you sure you want to edit this sms campaign?</p>
      <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeleteSmsCampaign == true">Are you sure you want to delete this sms campaign?</p>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-dark fw-bold" title="Cancel" [disabled]="savingSmsCampaign" (click)="hideSmsCampaignSaveConfirmModal()">
        No
      </button>

      <button type="button" class="btn btn-secondary text-white fw-bold" title="Create SMS Campaign" [disabled]="savingSmsCampaign" (click)="submitSmsCampaign()" *ngIf="pageMode == 'add' ||  (pageMode == 'edit' &&  isDeleteSmsCampaign == false)">
        Yes
        <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingSmsCampaign"></div>
      </button>

      <button type="button" class="btn btn-danger text-white fw-bold" title="Create SMS Campaign" [disabled]="savingSmsCampaign" (click)="deleteSmsCampaign()" *ngIf="pageMode == 'edit' &&  isDeleteSmsCampaign == true">
        Yes
        <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingSmsCampaign"></div>
      </button>
    </div>
  </ng-template>